<template>
  <div></div>
</template>

<script>
import NtrPaslaugosMap from './NtrPaslaugosMap'

export default {
  name: 'NtrSign',
  created() {
    this.redirectSign()
  },
  methods: {
    redirectSign() {
      const prasymasMap = NtrPaslaugosMap.getPrasymasTipas(
        this.$route.params.prasymasTipas
      )

      this.$router.push({
        name: prasymasMap.routeSign,
        params: {
          ...this.$route.params,
          step: 'registravimas',
          sign: true,
        },
      })
    },
  },
}
</script>
